import React from "react";
import { logOut } from "../utils/login";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import "../style/topBar.css";

import { MDBIcon } from "mdbreact";

function TopBar() {
  const loggedIn = useSelector((state) => state.login);
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <div className="topBarContainer">
      {loggedIn && (
        <button className="topBarButton">
          <MDBIcon far icon="user" />
          <Link to="/account"> Mon compte</Link>
        </button>
      )}
      <button className="topBarButton">
        <MDBIcon far icon="question-circle" />
        <Link to="/contact"> Nous contacter</Link>
      </button>
      {loggedIn ? (
        <button
          type="button"
          className="topBarButton"
          onClick={() => (
            logOut(), dispatch({ type: "LOGOUT" }), history.push("/login")
          )}
        >
          {" "}
          <MDBIcon icon="power-off" /> Déconnexion
        </button>
      ) : (
        <button className="topBarButton">
          <Link to="/login">
            <MDBIcon icon="user-tie" /> Connexion / Créer un compte
          </Link>
        </button>
      )}
    </div>
  );
}

export default TopBar;
